<template>
  <remaining-tasks-list
    title="Remaining Extraction Tasks"
    :tasks="tasks"
  />
</template>

<script>
import RemainingTasksList from './RemainingTasksList';
import { DataExtractionProgressSummary } from '@/models';

export default {
  name: 'DataExtractionRemainingTasksList',
  components: { RemainingTasksList },
  props: {
    progressSummary: {
      type: DataExtractionProgressSummary,
      required: true,
    },
  },
  computed: {
    tasks() {
      const tasks = [];
      if (this.drafts > 0) {
        tasks.push({
          key: 'drafts',
          text: "Extractions you've started",
          count: this.drafts,
        });
      }
      if (this.remainingUserCanExtract > 0) {
        tasks.push({
          key: 'votes',
          text: 'References needing extraction',
          count: this.remainingUserCanExtract,
        });
      }
      if (this.conflicts > 0) {
        tasks.push({
          key: 'conflicts',
          text: 'Awaiting consensus review',
          count: this.conflicts,
        });
      }

      return tasks;
    },
    drafts() {
      return this.progressSummary?.userDraftCount ?? 0;
    },
    remainingUserCanExtract() {
      return this.progressSummary?.remainingUserCanExtract() ?? 0;
    },
    conflicts() {
      return this.progressSummary?.conflictedExtractionCount ?? 0;
    },
  },
};
</script>
